/* /src/components/auth/logout.js */
import { AuthConsumer } from "./authProvider";
import { LoadingIndicator } from "../components/common/VFX-UI";

const Logout = () => (
  <AuthConsumer>
    {({ logout }) => {
      sessionStorage.removeItem("pledgeRedirectDone");
      logout();
      return <LoadingIndicator />;
    }}
  </AuthConsumer>
);

export default Logout;
